// @ts-strict-ignore
import React from 'react';

import { Hide } from 'components/Hide';
import { colors } from 'theme';

export function PageHeaderSeparator(props) {
  return (
    <Hide
      xs
      sm
      md
      width="1px"
      height={20}
      bg={colors.silver}
      opacity="0.5"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
